<template>
  <base-modal
    :title="$t('message.2fa.protectYourAccount')"
    :subtitle="$t('message.2fa.active2FA')"
    hook-sufix="Authentication2faApp"
    modal-width="600px"
    disableDefaultPadding
    :hasHelper="{
      text: $t('message.2fa.knowMore'),
      link: helperLink,
    }"
    twoFactorModal
    persistent
    :onOpenHook="generateSecretKey"
    :content-class="{
      'auth-2fa-app-modal--required': isRequired2faFromOrganization,
      'auth-2fa-app-modal': true,
    }"
  >
    <template #content>
      <div></div>
      <v-divider></v-divider>
      <v-row class="pa-6">
        <v-col cols="12" class="d-flex flex-column justify-center py-1">
          <span class="body-label-caption stepCount">{{
            $t('message.2fa.stepOne')
          }}</span>
          <p class="mb-0 body-regular-small stepTitle">
            {{ $t('message.2fa.stepOneExplanation') }}
          </p>
          <div class="authenticationServices">
            <div
              class="body-regular-small d-flex align-center justify-center authenticationServices--item"
              value="authy"
            >
              <img
                src="../../assets/authy-logo.svg"
                alt="Authy Logo"
                class="mr-2"
              />
              Authy
            </div>
            <div
              class="body-regular-small d-flex align-center justify-center authenticationServices--item"
              value="google"
            >
              <img
                src="../../assets/google-authenticator-logo.svg"
                class="mr-2"
                alt="Google Logo"
              />
              Google Authenticator
            </div>
          </div>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="pa-6">
        <v-col cols="12" class="d-flex flex-column justify-center py-1">
          <span class="body-label-caption stepCount">{{
            $t('message.2fa.stepTwo')
          }}</span>
          <p class="mb-2 body-regular-small stepTitle">
            {{ $t('message.2fa.scanQrCode') }}
          </p>

          <div
            v-if="showQrCode"
            class="d-flex flex-column justify-center align-center QrCodeStep pa-4"
          >
            <QrcodeVue
              :value="qrCodeValue"
              :size="124"
              level="L"
              bgColor="#FFFFFF"
              fgColor="#000000"
              renderAs="svg"
              class="px-3 pb-2 pt-3 qrCode"
            ></QrcodeVue>
            <a
              class="body-bold-smaller"
              type="secondary"
              @click="handleChangeShowQrCode"
              >{{ $t('message.2fa.canNotVerify') }}
            </a>
          </div>
          <div
            v-else
            height="1000px"
            class="QrCodeStep d-flex flex-column justify-center align-center pa-4"
          >
            <span class="d-flex mt-4 body-regular-smaller">{{
              $t('message.2fa.stepThreeExplanation')
            }}</span>
            <span class="body-bold-smaller mb-2">{{ qrCodeValue }}</span>

            <base-btn type="neutral" size="small" @click="handleCopyCode">{{
              $t('message.2fa.copyCode')
            }}</base-btn>
            <a
              type="secondary"
              class="body-bold-smaller mt-10"
              @click="handleChangeShowQrCode"
              >{{ $t('message.2fa.showQrCode') }}</a
            >
          </div>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="pa-6">
        <v-col cols="12" class="d-flex flex-column justify-center py-1">
          <span class="body-label-caption stepCount">{{
            $t('message.2fa.stepThree')
          }}</span>
          <p class="mb-2 body-regular-small stepTitle">
            {{ $t('message.2fa.stepThreeExplanation') }}
          </p>
          <v-otp-input
            ref="auth2faAppModalInput"
            v-model="codeApp"
            type="number"
            :length="6"
            :error="!!error"
            @finish="handleVerify"
            autocomplete="one-time-code"
            @focusin="otpRememberIndex"
            @keydown.stop="otpHandleKeydown"
          ></v-otp-input>
          <span v-if="error" class="error-message body-regular-smaller mt-2">
            {{ $t('message.2fa.wrongCode') }}
          </span>
        </v-col>
      </v-row>
    </template>

    <template #card-actions>
      <v-divider></v-divider>
      <v-card-actions class="pa-6 d-flex justify-space-between">
        <base-btn type="neutral" text @click="backToOptions">
          {{ $t('message.2fa.otherWay') }}
        </base-btn>
        <base-btn
          v-if="!isRequired2faFromOrganization"
          type="tertiary"
          :loading="isLoading"
          @click="handleCancel"
        >
          {{ $t('message.2fa.cancel') }}
        </base-btn>
      </v-card-actions>
    </template>
  </base-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import BaseModal from '../BaseModal.vue'
import QrcodeVue from 'qrcode.vue'
import twoFactorAuthApi from '@/services/twoFactorAuthApi'
import linkHelper from '@/utils/linkHelper.mixin.js'
import otpInputHandler from '@/utils/TwoFactorAuthMixins/otpInputHandler.mixin.js'

export default {
  name: 'Authentication2faApp',
  mixins: [linkHelper, otpInputHandler],
  components: {
    BaseModal,
    QrcodeVue,
  },
  data: () => ({
    verificationCode: '',
    isLoading: false,
    codeApp: '',
    authenticationService: 1,
    qrCodeValue: '',
    showQrCode: true,
    secretKey: '',
    error: null,
    rules: {
      required: (v) => !!v || 'Campo obrigatório',
    },
    isRequired2faFromOrganization: false,
    opennedFromRequired2faModal: false,
    openned2faFromProfile: false,
  }),
  props: {
    otpRef: { default: 'auth2faAppModalInput' },
    otpModelKey: { default: 'codeApp' },
  },
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
      userAllInfo: (state) => state.user.userAllInfo,
    }),
    serviceSelected() {
      const authenticationService = ['authy', 'google']
      let serviceSelected = authenticationService[this.authenticationService]
      return serviceSelected
    },
    isValid() {
      return this.codeApp.length === 6 && /^\d+$/.test(this.codeApp)
    },
    helperLink() {
      return this.enableTwoFactorAuthenticationHelper()
    },
  },
  updated() {
    this.showQrCode = true
  },
  async mounted() {
    this.showQrCode = true
    this.error = null
    this.$root.$on('2faRequiredFromOrganization', (isRequired) => {
      this.isRequired2faFromOrganization = isRequired
    })
    this.$root.$on('opennedFromRequired2faModal', (val) => {
      this.opennedFromRequired2faModal = val
    })
    this.$root.$on('openned2faFromProfile', () => {
      this.openned2faFromProfile = true
    })
    await this.generateSecretKey()
  },
  methods: {
    ...mapMutations('user', ['UPDATE_USER_ALLINFO']),
    async generateSecretKey() {
      this.focusInput()
      try {
        this.isLoading = true
        this.error = null
        const response = await twoFactorAuthApi.mfaSetup({ type: 'app' })
        this.secretKey = response.code

        this.qrCodeValue = `otpauth://totp/${encodeURIComponent(
          'Panda Video'
        )}:${encodeURIComponent(
          this.$store.state.user.userInfo.email
        )}?secret=${this.secretKey}&issuer=${encodeURIComponent('Panda Video')}`
      } catch (error) {
        console.error('Erro ao gerar chave secreta:', error)
        this.error = this.$t('message.2fa.setupError')
      } finally {
        this.isLoading = false
      }
    },
    async handleCopyCode() {
      try {
        await navigator.clipboard.writeText(this.secretKey)
        // this.UPDATE_GLOBAL_SNACKBAR({ open: true, text: this.$t('message.2fa.copyError') })
      } catch (error) {
        console.error('Failed to copy text: ', error)
      }
    },
    handleChangeShowQrCode() {
      this.showQrCode = !this.showQrCode
      this.error = null
      if (this.showQrCode) {
        this.qrCodeValue = `otpauth://totp/${encodeURIComponent(
          'Panda Video'
        )}:${encodeURIComponent(
          this.$store.state.user.userInfo.email
        )}?secret=${this.secretKey}&issuer=${encodeURIComponent('Panda Video')}`
        return
      }
      this.qrCodeValue = this.secretKey
    },
    handleCancel() {
      this.error = null
      this.$root.$emit('closeAuthentication2faApp')
      this.showQrCode = true
    },
    backToOptions() {
      this.error = null
      this.showQrCode = true
      this.$root.$emit('closeAuthentication2faApp')
      this.$root.$emit('openTwoFactorAuth')
    },
    async handleVerify() {
      if (!this.isValid) {
        this.error = this.$t('message.2fa.invalidCode')
        return
      }

      this.error = null
      this.isLoading = true

      try {
        await twoFactorAuthApi.mfaVerify({
          code: this.codeApp,
        })

        const currentUserInfo = this.userAllInfo || {}
        const updatedUserInfo = {
          ...currentUserInfo,
          mfa_enable: true,
          mfa_methods: [...(currentUserInfo.mfa_methods || []), 'app'],
        }
        this.UPDATE_USER_ALLINFO(updatedUserInfo)

        this.showQrCode = true
        this.$root.$emit('closeAuthentication2faApp')
        this.$root.$emit('auth2faCreated')
        if (!this.opennedFromRequired2faModal && !this.openned2faFromProfile) {
          this.$root.$emit('openEnable2FAModal')
        }
        this.$root.$emit('updateMfaStatus', true)
      } catch (error) {
        console.error('Erro na verificação:', error)
        this.error = this.$t('message.2fa.wrongCode')
      } finally {
        this.isLoading = false
      }
    },
    focusInput() {
      this.$nextTick(() => {
        const otpInput = this.$refs.auth2faAppModalInput
        if (otpInput?.focus) {
          otpInput.focus()
        } else {
          otpInput?.$el.querySelector('input')?.focus()
        }
      })
    },
  },
  watch: {
    codeApp() {
      this.error = null
    },
  },
  beforeDestroy() {
    this.$root.$off('2faRequiredFromOrganization')
    this.$root.$off('opennedFromRequired2faModal')
  },
}
</script>

<style lang="scss">
.twoFactorModal {
  .v-chip.figma-chip {
    height: 72px;
    width: 50%;
  }
}

.auth-2fa-app-modal--required {
  .v-toolbar__items {
    display: none;
  }
}

.auth-2fa-app-modal {
  :deep(.modal-content) {
    height: 100%;
  }
  :deep(.modal-body) {
    overflow-y: auto;
  }
}

.auth-2fa-app-modal {
  .theme--dark.v-otp-input .v-input .v-input__control .v-input__slot {
    background: transparent !important;
  }
}
</style>

<style lang="scss" scoped>
.authenticationServices {
  display: flex;
  gap: 8px;
  margin-top: 0.5rem;
  &--item {
    border: 1px solid varFigma(neutral-95-lightest);
    border-radius: 8px;
    width: 50%;
    padding: 1rem 0;
  }
}
.QrCodeStep {
  border-radius: 8px;
  background-color: varFigma(neutral-background);

  .qrCode {
    padding: 1rem;
    background-color: #ffffff;
  }
}

.twoFactorModal {
  .stepCount {
    color: varFigma(neutral-50);
  }
  .stepTitle {
    color: varFigma(neutral-20-dark);
  }
}

.error-message {
  color: varFigma(error);
  display: block;
  text-align: center;
}
</style>
